module.exports = __webpack_public_path__ + "static/media/dabajianshan_web.71e38a07.png";